import {Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip} from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { useContext } from "react";
import { store } from "../../Store/store";
import {
    DISCONNECTED, DOWNLOADING, ERROR, OK, PAIRED, PAIRING, SWITCHING, TRAFFIC_ISSUE_SUSPECT, UNKNOWN_ENUM,
    UNPAIRED, UNPAIRING, WAIT_GET_GUID_RES, WAIT_RESET_ADDR_RES, WAIT_SET_ADDR_RES, WAIT_SET_GREEN_LED_RES
} from "./Types";
import { CiCircleQuestion } from "react-icons/ci";
import PairVmaBySerialNumberModal from "./PairVmaBySerialNumberModal";

export default function EditVmaModal(props) {
    const stateObj = useContext(store);
    const [isSavingInProgress, setIsSavingInProgress] = useState(false);
    const [nameValue, setNameValue] = useState(props.selectedVmaRow?.name);
    const [showPairVmaBySerialNumber, setShowPairVmaBySerialNumberModal] = useState(false);

    const getCurrentVmaState = () => {
        const currentVma = stateObj.state.vmaListArr.filter((obj) => obj.uuid === props.selectedVmaRow.uuid);
        return currentVma[0];
    }

    const handlePair = () => {
        getCurrentVmaState();
        props.setIsPollingInProgress(true);
        props.setIsPairClicked(true);
        props.setSelectedVmaRow({...props.selectedVmaRow, pairingState: PAIRING});
        const newVmaData = props.vmaData.map((obj) => {
            if (obj.uuid === props.selectedVmaRow.uuid) {
                return {...obj, pairingState: PAIRING};
            } else {
                return obj;
            }
        });
        props.setVmaData(newVmaData);
        props.setPairingVmaUuid(props.selectedVmaRow.uuid);
        props.controlUnitService.pairVma(props.controlUnitId, props.selectedVmaRow.uuid);
    }

    const handleUnPair = () => {
        props.setIsPollingInProgress(true);
        props.setIsPairClicked(true);
        props.setSelectedVmaRow({...props.selectedVmaRow, pairingState: UNPAIRING});
        const newVmaData = props.vmaData.map((obj) => {
            if (obj.uuid === props.selectedVmaRow.uuid) {
                return {...obj, pairingState: UNPAIRING};
            } else {
                return obj;
            }
        });
        props.setVmaData(newVmaData);
        props.setPairingVmaUuid(props.selectedVmaRow.uuid);
        props.controlUnitService.unpairVma(props.controlUnitId, props.selectedVmaRow.uuid);
    }

    const handleDownload = () => {
        props.setIsPollingInProgress(true);
        props.setIsDownloadClicked(true);
        props.setSelectedVmaRow({...props.selectedVmaRow, firmwareDownloadState: DOWNLOADING});
        const newVmaData = props.vmaData.map((obj) => {
            if (obj.uuid === props.selectedVmaRow.uuid) {
                return {...obj, firmwareDownloadState: DOWNLOADING};
            } else {
                return obj;
            }
        });
        props.setVmaData(newVmaData);
        props.setDownloadingFirmwareVmaId(props.selectedVmaRow.uuid);
        props.controlUnitService.downloadVmaFirmware(props.controlUnitId, props.selectedVmaRow.uuid);
    }

    const handleSwitch = () => {
        props.setIsPollingInProgress(true);
        props.setIsSwitchClicked(true);
        props.setSelectedVmaRow({...props.selectedVmaRow, firmwareSwitchState: SWITCHING});
        const newVmaData = props.vmaData.map((obj) => {
            if (obj.uuid === props.selectedVmaRow.uuid) {
                return {...obj, firmwareSwitchState: SWITCHING};
            } else {
                return obj;
            }
        });
        props.setVmaData(newVmaData);
        props.setSwitchingFirmwareVmaId(props.selectedVmaRow.uuid);
        props.controlUnitService.switchVmaFirmware(props.controlUnitId, props.selectedVmaRow.uuid);
    }

    const handleOk = async () => {
        let editedObj;
        props.vmaData.forEach((obj) => {
            if (obj.uuid === props.selectedVmaRow.uuid) {
                editedObj = {...obj, name: nameValue};
            }
        });
        setIsSavingInProgress(true);
        await props.editVma(editedObj, props.selectedVmaRow.uuid);
        setIsSavingInProgress(false);
    }

    const handleCancel = () => {
        props.setShow(false);
    }

    const renderPairButton = () => {
        const selectedVmaRow = props.selectedVmaRow;
        if (!selectedVmaRow?.pairingState || [ERROR, UNKNOWN_ENUM, WAIT_SET_ADDR_RES, WAIT_RESET_ADDR_RES, WAIT_GET_GUID_RES, WAIT_SET_GREEN_LED_RES, TRAFFIC_ISSUE_SUSPECT].includes(selectedVmaRow?.pairingState)) {
            return <Button disabled={true} variant="primary">Pair</Button>;
        }
        if (selectedVmaRow?.pairingState === UNPAIRED) {
            return <Button disabled={props.isPollingInProgress || isSavingInProgress} onClick={() => handlePair()} variant="primary">Pair</Button>;
        }
        if (selectedVmaRow?.pairingState === PAIRING) {
            return (<Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className='mr-1'
                    />
                    Pairing...
                </Button>
            );
        }
        if (selectedVmaRow?.pairingState === UNPAIRING) {
            return (<Button variant="primary" disabled>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className='mr-1'
                    />
                    Unpairing...
                </Button>
            );
        }
        if (selectedVmaRow?.pairingState === PAIRED || selectedVmaRow?.pairingState === DISCONNECTED) {
            return <Button disabled={props.isPollingInProgress} style={{width: 80}} onClick={() => handleUnPair()} variant="primary">Unpair</Button>;
        }
    }

    const renderPairVmaBySerialButton = () => {
        const selectedVmaRow = props.selectedVmaRow;
        if (!selectedVmaRow?.pairingState || [ERROR, UNKNOWN_ENUM, WAIT_SET_ADDR_RES, WAIT_RESET_ADDR_RES, WAIT_GET_GUID_RES, WAIT_SET_GREEN_LED_RES, TRAFFIC_ISSUE_SUSPECT].includes(selectedVmaRow?.pairingState)) {
            return <Button onClick={()=>setShowPairVmaBySerialNumberModal(true)} disabled={false} variant="primary">Pair By Serial Number</Button>;
        }
        if (selectedVmaRow?.pairingState === UNPAIRED) {
            return <Button  disabled={props.isPollingInProgress || isSavingInProgress} onClick={() => setShowPairVmaBySerialNumberModal(true)} variant="primary">Pair By Serial Number</Button>;
        }
        if (selectedVmaRow?.pairingState === PAIRED || selectedVmaRow?.pairingState === DISCONNECTED) {
            return null;
        }
    }

    useEffect(() => {
        props.vmaData?.forEach(vma => {
            if (vma.uuid === props.selectedVmaRow?.uuid) {
                props.setSelectedVmaRow(vma);
            }
        });
    }, [props.vmaData]);

    useEffect(() => {
        if (props.selectedVmaRow) {
            setNameValue(props.selectedVmaRow.name);
        }
    }, [props.selectedVmaRow]);

    useEffect(() => {}, [props.isPollingInProgress]);

    return (
        <>
            {showPairVmaBySerialNumber && (
                <>
                    <PairVmaBySerialNumberModal
                        isPollingInProgress={props.isPollingInProgress}
                        selectedVmaRow={props.selectedVmaRow}
                        show={showPairVmaBySerialNumber}
                        setIsPairClicked={props.setIsPairClicked}
                        setShow={setShowPairVmaBySerialNumberModal}
                        setIsPollingInProgress={props.setIsPollingInProgress}
                        vmaData={props.vmaData}
                        setVmaData={props.setVmaData}
                        setPairingVmaUuid={props.setPairingVmaUuid}
                        setSelectedVmaRow={props.setSelectedVmaRow}
                        controlUnitService={props.controlUnitService}
                        controlUnitId={props.controlUnitId}
                    />
                </>
            )}
            <Modal dialogClassName="filter-modal" show={props.show} onHide={() => {
                if (!isSavingInProgress) {
                    props.setShow(false);
                }
            }} style={{ marginTop: '10%', left: '-10%', width: '2300px', zIndex: showPairVmaBySerialNumber ? 1030 : null }}>
                <Modal.Header closeButton>a
                    <Modal.Title>Edit VMA</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col} md={8} controlId="formGridId1">
                                <Form.Label>UUID:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.uuid} readOnly/>
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridModel">
                                <Form.Label>Serial Number:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.serialNumber} readOnly/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md={8} controlId="formGridName">
                                <Form.Label>Name:</Form.Label>
                                <Form.Group as={Row} controlId="formGridName1">
                                    <Col className={'pr-0'} md={11}>
                                        <Form.Control disabled={props.isPollingInProgress} value={nameValue} onChange={e => setNameValue(e.target.value)} />
                                    </Col>
                                    <Col className={'p-0'}>
                                        <OverlayTrigger
                                            placement="right"
                                            overlay={
                                                <Tooltip id="tooltip-right">
                                                    Naming convention:
                                                    <br/>
                                                    &lt;Water System Name&gt;_Supply
                                                    <br/>
                                                    or
                                                    <br/>
                                                    &lt;Water System Name&gt;_Return
                                                </Tooltip>
                                            }
                                        >
                                            <span style={{marginLeft: '5px', cursor: 'pointer'}}><CiCircleQuestion className={'mt-1 mr-1'} size={30} color={'#007BFF'}/></span>
                                        </OverlayTrigger>
                                    </Col>
                                </Form.Group>
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridModel">
                                <Form.Label>Model:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.modbusModel} readOnly/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGridH/wVersion">
                                <Form.Label>H/W Version:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.hardwareVersion} readOnly/>
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridFirmware">
                                <Form.Label>Firmware:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.softwareVersion} readOnly/>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} controlId="formGrid#Devices">
                                <Form.Label># Devices:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.numberOfDevices} readOnly/>
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridAddress">
                                <Form.Label>Address:</Form.Label>
                                <Form.Control value={props.selectedVmaRow?.address} readOnly/>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                        <div>
                            <div className='d-inline-block mr-2'>
                                {renderPairButton()}
                            </div>
                            <div className='d-inline-block mr-2'>
                                {renderPairVmaBySerialButton()}
                            </div>
                        </div>
                        <div>
                            <div className='d-inline-block mr-2'>
                                {
                                    isSavingInProgress ?
                                        <Button disabled variant="primary">
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                className='mr-1'
                                            />
                                            Saving...
                                        </Button>
                                        :
                                        <Button disabled={props.isPollingInProgress} style={{width: 80}} onClick={() => handleOk()} variant="primary">OK</Button>
                                }
                            </div>
                            <div className='d-inline-block'>
                                <Button disabled={isSavingInProgress} style={{width: 80}} onClick={() => handleCancel()} variant="primary">Cancel</Button>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}
